import styled from "styled-components";
import colors from "styles/colors";

export const Text = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  min-height: 20px;
  font-family: "OpenSansRegular";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${colors.gray70};
`;
